/**
 * @fileoverview Post Box Controller - contains the business logic and data for the post box.
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.provide('yext.social.post.PostBoxController');

goog.require('yext');
goog.require('yext.dam.routes');
goog.require('yext.dialog');
goog.require('yext.fileupload');
goog.require('yext.notify');
goog.require('yext.plugins.ActionMenu');
goog.require('yext.social.post.dialogs.MissingAccountsDialog');
goog.require('yext.social.post.dialogs.MissingPermissionsDialog');
goog.require('yext.social.post.dialogs.MissingFieldsDialog');
goog.require('yext.social.post.dialogs.NoLinkedAccountDialog');
goog.require('yext.social.post.dialogs.SuccessDialog');
goog.require('yext.social.post.PostContentController');
goog.require('yext.social.post.PostDestinationController');
goog.require('yext.social.post.PostFieldConfiguration');
goog.require('yext.social.post.PostValidator');
goog.require('yext.social.post.ScheduleDateView');
goog.require('yext.socialstorm.routes');

/** @constructor */
yext.social.post.PostBoxController = function(options) {
  this.options = options || {};

  /** @type {!jQuery} */
  this.$ctxt = this.options.$ctxt || $('.js-post-box-container');

  /** @type {yext.social.post.PostFieldConfiguration} */
  this.fieldConfiguration = new yext.social.post.PostFieldConfiguration(
    this.options.partners || [],
    this.options.postablePartners || []);

  /** @type {yext.social.post.PostValidator} */
  this.validator = new yext.social.post.PostValidator(this.fieldConfiguration);

  /** @type {yext.social.post.PostDestinationController} */
  this.postDestinationController = new yext.social.post.PostDestinationController({
    $ctxt: this.$ctxt.find('.js-post-destination-container'),
    partners: this.options.partners || [],
    postablePartners: this.options.postablePartners || [],
    preferredPartners: this.options.preferredPartners || [],
    numAdvancedSearchLocations: this.options.numAdvancedSearchLocations || 0,
    locations: this.options.locations || [],
    existingPost: this.options.existingPost || {},
    onSelectPartner: this.onSelectPartner_.bind(this),
    shouldShowLocationSelector: this.options.shouldShowLocationSelector || false,
    locationEntityTypeIds: this.options.locationEntityTypeIds || [],
  }).init();

  /** @type {yext.social.post.PostContentController} */
  this.postContentController = new yext.social.post.PostContentController({
    $ctxt: this.$ctxt.find('.js-post-content-container'),
    getLocationSearchParam: this.encodeLocationSearchParam_.bind(this),
    calculateRemainingCharacters: this.validator.calculateRemainingCharacters.bind(this.validator),
    isFieldAllowed: this.fieldConfiguration.isFieldAllowed.bind(this.fieldConfiguration),
    isFieldAllowedForAnyPartner: this.fieldConfiguration.isFieldAllowedForAnyPartner
      .bind(this.fieldConfiguration),
    existingPost: this.options.existingPost || {},
    getPartnerIds: function() {
      return this.postDestinationController.getData()['partnerIds'];
    }.bind(this),
  }).init();

  /** @type {yext.social.post.ScheduleDateView} */
  this.scheduleDateView = new yext.social.post.ScheduleDateView({
    $el: this.$ctxt.find('.js-schedule-post-dialog'),
    timezones: this.options.timezones || [],
  }).init();

  /** @type {!Object} populated from scheduledDateView as it gets applied **/
  this.scheduledDate = {};

  /** @type {yext.social.post.dialogs.MissingAccountsDialog} */
  this.missingAccountsDialog = new yext.social.post.dialogs.MissingAccountsDialog(
    this.submitPost_.bind(this), this.cancelPost_.bind(this)).init();

  /** @type {yext.social.post.dialogs.MissingPermissionsDialog} */
  this.missingPermissionsDialog = new yext.social.post.dialogs.MissingPermissionsDialog(
    this.submitPost_.bind(this), this.cancelPost_.bind(this)).init();

  /** @type {yext.social.post.dialogs.MissingFieldsDialog} */
  this.missingFieldsDialog = new yext.social.post.dialogs.MissingFieldsDialog(
    this.submitPost_.bind(this), this.cancelPost_.bind(this)).init();

  /** @type {yext.social.post.dialogs.NoLinkedAccountDialog} */
  this.noLinkedAccountDialog = new yext.social.post.dialogs.NoLinkedAccountDialog(
    this.cancelPost_.bind(this)).init();

  /** @type {yext.social.post.dialogs.SuccessDialog} */
  this.successDialog = new yext.social.post.dialogs.SuccessDialog().init();
};

/**
 * @const
 * @type {number}
 */
yext.social.post.PostBoxController.TIMEOUT_CODE = 504;

/**
 * @const
 * @type {string}
 */
yext.social.post.PostBoxController.BLUR_POSTBOX_HEIGHT = '40px';

/** @return this */
yext.social.post.PostBoxController.prototype.init = function() {
  this.bindPostBoxFocus_();
  this.bindPostDestinations_();
  this.bindPostContent_();
  this.bindScheduleDateView_();
  this.bindSubmitActions_();
  this.toggleSubmitButton_();
  this.fieldConfiguration.setAvailablePartners(this.getData()['partnerIds']);
  this.postContentController.updateFieldConfiguration();

  return this;
};

/** @return {!Object<string, ?>} */
yext.social.post.PostBoxController.prototype.getData = function() {
  return $.extend(
    true,
    {},
    this.postDestinationController.getData(),
    this.postContentController.getData());
};

/**
 * Populates the postbox with the data in the given post
 * @param {!Object<string, ?>} post
 */
yext.social.post.PostBoxController.prototype.populate = function(post) {
  post = post || {};
  this.reset_();
  this.expandPostBox_(function() {
    this.postDestinationController.populate(post['destinations'] || {});
    this.postContentController.populate(post['content'] || {});
  }.bind(this));
};

/**
 * Binds expanding the postbox on focus
 * @private
 */
yext.social.post.PostBoxController.prototype.bindPostBoxFocus_ = function() {
  if (this.options.alwaysOpened) {
    this.$ctxt.removeClass('minimized');
    this.toggleSubmitButton_();
    return;
  }

  this.$ctxt.find('.js-post-text-box').on('focus', function() {
    this.expandPostBox_();
  }.bind(this));
};

/** @private */
yext.social.post.PostBoxController.prototype.expandPostBox_ = function(cb) {
  var slideShow = function($el) {
    if (!$el.is(':visible')) {
      $el.slideDown({
        'complete': function() {
          $el.css('display', '');
        },
      });
    }
  };

  if (!this.$ctxt.hasClass('minimized')) {
    if (yext.isFunction(cb)) {
      cb();
    }
    return;
  }

  this.$ctxt.find('.js-post-content-container').animate({
    'height': 'auto',
  }, {
    'done': function() {
      slideShow(this.$ctxt.find('.js-post-photo-container'));
      slideShow(this.$ctxt.find('.js-post-header'));
      slideShow(this.$ctxt.find('.js-post-error'));
      slideShow(this.$ctxt.find('.js-post-event-container'));
      slideShow(this.$ctxt.find('.js-post-call-to-action-container'));
      slideShow(this.$ctxt.find('.js-post-actions-container'));
      this.$ctxt.removeClass('minimized');
      this.toggleSubmitButton_();
      if (yext.isFunction(cb)) {
        cb();
      }
    }.bind(this),
  });
};

/**
 * Minimizes the postbox
 * @private
 */
yext.social.post.PostBoxController.prototype.minimizePostBox_ = function() {
  if (!this.options.alwaysOpened) {
    var $contentContainer = this.$ctxt.find('.js-post-content-container');
    $contentContainer.animate({
      'height': yext.social.post.PostBoxController.BLUR_POSTBOX_HEIGHT,
    }, {
      'complete': function() {
        this.$ctxt.addClass('minimized');
        $contentContainer.css('height', '');
      }.bind(this),
    });
    this.$ctxt.find('.js-post-photo-container').slideUp();
    this.$ctxt.find('.js-post-header').slideUp();
    this.$ctxt.find('.js-post-error').slideUp();
    this.$ctxt.find('.js-post-event-container').slideUp();
    this.$ctxt.find('.js-post-call-to-action-container').slideUp();
    this.$ctxt.find('.js-post-actions-container').slideUp();
  }
};

/** @private */
yext.social.post.PostBoxController.prototype.bindPostDestinations_ = function() {
  this.postDestinationController.beforeChange(function(data) {
    if (data['locationIds'] || data['folderIds'] || data['locationLabelIds']) {
      this.beforeLocationScopeChange_(data);
    }
  }.bind(this));

  this.postDestinationController.onChange(function(data) {
    if (data['partnerIds']) {
      this.fieldConfiguration.setAvailablePartners(data['partnerIds']);
    }
    this.postContentController.updateFieldConfiguration();
    this.toggleSubmitButton_();
  }.bind(this));
};

/** @private */
yext.social.post.PostBoxController.prototype.bindPostContent_ = function() {
  this.postContentController.onChange(function(data) {
    this.toggleSubmitButton_();
  }.bind(this));
};

/** @private */
yext.social.post.PostBoxController.prototype.bindScheduleDateView_ = function() {
  this.scheduleDateView.onApply(function() {
    this.scheduledDate = this.scheduleDateView.getData();
    this.handleSubmitPost_({} /* opts */);
  }.bind(this));
};

yext.social.post.PostBoxController.prototype.cancelPost_ = function() {
  this.scheduleDateView.reset();
  this.scheduleDate = {};
};

/** @private */
yext.social.post.PostBoxController.prototype.bindSubmitActions_ = function() {
  var $menu = this.$ctxt.find('.js-submit-action-menu');
  yext.plugins.ActionMenu.initialize($menu);
  $menu.find('.js-submit-post').on('click', function() {
    this.handleSubmitPost_();
  }.bind(this));

  $menu.find('.js-schedule-post').on('click', function(e) {
    e.stopPropagation();
    this.scheduleDateView.show($menu);
  }.bind(this));

  this.$ctxt.find('.js-cancel').on('click', function() {
    this.reset_();
    this.minimizePostBox_();
  }.bind(this));
};

/** @private */
yext.social.post.PostBoxController.prototype.handleSubmitPost_ = function(opts) {
  var publisherSpecificError = this.validator.doPublisherSpecificValidation(this.getData());
  if (publisherSpecificError) {
    this.$ctxt.find('.js-post-error')
      .text(publisherSpecificError)
      .show();
    return;
  }
  if (!this.validator.hasPartialEventAndCTASupport(this.getData())) {
    this.confirmPost_(opts);
    return;
  }

  yext.dialog.showSubmitDialog({
    'onSubmit': this.confirmPost_.bind(this, opts),
    'title': yext.msg('Submit Post'),
    'message': yext.msg('Event and Call to Action fields will not be posted to any site ' +
                         'besides Google Local Posts'),
    'dontHide': !this.isPostToSelection_(),
  });
};

/**
 * Shows confirmation dialog if the user chooses to post to all locations and has >1 location
 * @private
 */
yext.social.post.PostBoxController.prototype.confirmPost_ = function(opts) {
  if (this.isPostToSelection_()) {
    this.submitPost_(opts);
    return;
  }

  yext.dialog.showSubmitDialog({
    'onSubmit': this.submitPost_.bind(this, opts),
    'title': yext.msgc('social posting', 'Post to All Locations'),
    'message': yext.msgc('social posting', 'Are you sure you want to post to all locations?'),
    'submitButtonText': yext.msgc('social posting', 'Post'),
  });
};

/**
 * @private
 * @return true if business only has 1 postable location, or if post is filtered by location,
 *  folder, and/or label IDs
 */
yext.social.post.PostBoxController.prototype.isPostToSelection_ = function() {
  var postDestinationData = this.postDestinationController.getData();
  return this.options.numPostableLocations == 1
    || postDestinationData['locationIds'].length > 0
    || postDestinationData['folderIds'].length > 0
    || postDestinationData['locationLabelIds'].length > 0;
};

/**
 * @private
 * @param {!Object<string, boolean>} opts
 */
yext.social.post.PostBoxController.prototype.submitPost_ = function(opts) {
  this.toggleSubmit_(false /* enabled */);
  opts = opts || {};
  var dialogTimeout = yext.dialog.showDelayedProgressDialog(yext.msg('Posting...'));
  var postData = this.getPostSubmitData_(opts);
  var submitDone = function() {
    this.toggleSubmit_(true /* enabled */);
    yext.dialog.hideDelayedProgressDialog(dialogTimeout);
  }.bind(this);
  var submitSuccess = function(data) {
    submitDone();
    if (data['success']) {
      this.handleSubmitSuccess_(data);
    } else {
      this.handleSubmitError_(data, opts);
      yext.notify.showError(yext.msg('Post Failed.'));
    }
  }.bind(this);
  var submitError = function(status) {
    submitDone();
    var error;
    if (status == yext.social.post.PostBoxController.TIMEOUT_CODE) {
      error = yext.msg('It seems like your post is taking a while. ' +
                           'Please try refreshing this page in a few minutes.');
      this.reset_();
      this.minimizePostBox_();
    }
    this.handleSubmitError_({
      'error': error,
    }, opts);
  }.bind(this);

  // abort any outstanding photo upload request in case it is not finished yet
  this.postContentController.abortPhotoUploadAjaxRequest();

  if (postData['files']) {
    yext.fileupload.upload($.extend(true, {}, postData, {
      action: yext.socialstorm.routes.SocialPost.createPost(yext.getUrlParams()),
      dataType: 'json',
      done: submitSuccess,
      error: submitError,
    }));
  } else {
    $.ajax({
      url: yext.socialstorm.routes.SocialPost.createPost(yext.getUrlParams()),
      type: 'POST',
      data: postData.data,
      success: submitSuccess,
      error: submitError,
    });
  }
};

/**
 * @private
 * @param {!Object<string, boolean>} opts
 * @return {!Object<string, ?>} post
 */
yext.social.post.PostBoxController.prototype.getPostSubmitData_ = function(opts) {
  var self = this;
  var data = this.getData();
  var photo = data.photo;
  var photoUrl = photo ? photo.url : undefined;
  var photoWidth = photo ? photo.width : undefined;
  var photoHeight = photo ? photo.height : undefined;
  var assetId = photo ? photo.assetId : undefined;
  var eventTitle = data['event'] ? data['event']['title'] : undefined;
  var eventStartTime = function() {
    var startTime = data['event'] ? data['event']['startTime'] : undefined;
    return startTime ? startTime.getTime() : undefined;
  }();
  var eventEndTime = function() {
    var endTime = data['event'] ? data['event']['endTime'] : undefined;
    return endTime ? endTime.getTime() : undefined;
  }();
  var callToAction = data['callToAction'];
  var callToActionTypeId = callToAction ? callToAction['callToActionTypeId'] : undefined;
  var callToActionCustomFieldId = callToAction ? callToAction['customFieldId'] : undefined;
  var callToActionUrlField = callToAction ? callToAction['urlField'] : undefined;

  // TODO(hydra): Make this into the new post model
  var post = [
    {name: 'message', value: data['message']},
    {name: 'folderId', value: data['folderIds']},
    {name: 'locationId', value: data['locationIds']},
    {name: 'locationLabelIds', value: data['locationLabelIds']},
    {name: 'link', value: data['hyperlink']['link']},
    {name: 'linkTitle', value: data['hyperlink']['linkTitle']},
    {name: 'linkSubtitle', value: data['hyperlink']['linkSubtitle']},
    {name: 'linkSummary', value: data['hyperlink']['linkSummary']},
    {name: 'force', value: !!opts.force},
    {name: 'emptyForce', value: !!opts.emptyForce},
    {name: 'emptySkip', value: !!opts.emptySkip},
    {name: 'usesSelector', value: data['usesSelector']},
    {name: 'permissionsForce', value: !!opts.permissionsForce},
    {name: 'shareReview', value: this.options.shareReview || false},
    {name: 'targetPartners', value: data['partnerIds']},
    {name: 'eventTitle', value: eventTitle},
    {name: 'eventStartTime', value: eventStartTime},
    {name: 'eventEndTime', value: eventEndTime},
    {name: 'callToActionTypeId', value: callToActionTypeId},
    {name: 'callToActionCustomFieldId', value: callToActionCustomFieldId},
    {name: 'callToActionUrlOrCustomFieldName', value: callToActionUrlField},
  ];

  if (photo) {
    post.push({name: 'photoUrl', value: photoUrl});
    post.push({name: 'photoWidth', value: photoWidth});
    post.push({name: 'photoHeight', value: photoHeight});
    post.push({name: 'assetId', value: assetId});
  }

  if (this.options.existingPost != null) {
    post.push({name: 'sourcePostId', value: this.options.existingPost.sourcePostId});
  }

  if (data['asset'] && !photo) {
    if (data['asset']['croppedImage']) {
      post.push({name: 'croppedImage', value: data['asset']['croppedImage']});
      post.push({name: 'croppedImageName', value: data['asset']['file']
        ? data['asset']['file']['name']
        : data['asset']['photoUrl']});
    }
    if (!photoUrl) {
      post.push({name: 'photoUrl', value: data['asset']['photoUrl']});
    }
    post.push({name: 'assetId', value: data['asset']['id']});

    if (!data['asset']['id']) {
      post.push({name: 'sourceUrl', value: data['asset']['sourceUrl']});
    }
  }

  var hasScheduledDate = this.options.hasScheduledPosting
      && this.scheduledDate['scheduledDate']
      && this.scheduledDate['userTimeZoneId']
      && this.scheduledDate['destinationTimeZoneId'];

  if (hasScheduledDate) {
    post.push({name: 'scheduledPostDate', value: this.scheduledDate['scheduledDate']});
    post.push({name: 'userTimeZoneId', value: this.scheduledDate['userTimeZoneId']});
    post.push({name: 'destinationTimeZoneId', value: this.scheduledDate['destinationTimeZoneId']});
  } else {
    post.push({name: 'userTimeZoneId', value: this.scheduleDateView.getUserTimeZoneId()});
  }

  if (data['asset'] && data['asset']['file'] && !photo) {
    return {
      'files': [data['asset']['file']],
      'fileInputs': [data['asset']['fileInput']],
      'data': post,
    };
  } else {
    return {
      data: post,
    };
  }
};

/**
 * @private
 * @param {!Object<string, ?>} data
 */
yext.social.post.PostBoxController.prototype.handleSubmitSuccess_ = function(data) {
  this.successDialog.open(data);
  this.reset_();
  this.minimizePostBox_();
  $.event.trigger('newPost.social', [data]);
};

/**
 * @private
 * @param {!Object<string, ?>} data
 * @param {!Object<string, boolean>} opts
 */
yext.social.post.PostBoxController.prototype.handleSubmitError_ = function(data, opts) {
  data = data || {};
  if (data['missingAccounts']) {
    if (data['linkedAccounts'] > 0) {
      this.missingAccountsDialog.open(data, opts);
    } else {
      this.noLinkedAccountDialog.open();
    }
  } else if (data['reauth'] > 0) {
    $('#post-reauth-dialog').dialog('open');
  } else if (data['emptyCount'] > 0) {
    this.missingFieldsDialog.open(data, opts);
  } else if (data['missingPermissions'] > 0) {
    this.missingPermissionsDialog.open(data, opts);
  } else if (data['duplicate'] > 0) {
    $('#post-duplicate-dialog').dialog('open');
  } else {
    var error = data['error'] || yext.msg(
      'An unexpected error occurred. Try again later, or contact support for further assistance.');
    yext.dialog.showErrorDialog(error);
  }
};

/** @private */
yext.social.post.PostBoxController.prototype.reset_ = function() {
  this.postContentController.reset();
  this.postDestinationController.reset();
  this.scheduleDateView.reset();
  this.scheduledDate = {};
};

yext.social.post.PostBoxController.prototype.beforeLocationScopeChange_ = function() {
  var photoData = this.postContentController.getData()['asset'];
  if (!!photoData && !!photoData['id']) {
    $.ajax({
      url: goog.module.get('yext.dam.routes').default.validateAssetScope(),
      type: 'GET',
      data: {
        'assetId': photoData['id'],
        'locationSearchParam': this.encodeLocationSearchParam_(),
      },
    })
      .done(function(data) {
        if (!data['matchesAssetScope']) {
          yext.dialog.showSubmitDialog({
            title: yext.msg('Invalid Asset'),
            message: yext.msg(
              'The photo asset you have selected for your post is not available for the ' +
            'selected locations. If you continue, the selected asset will be cleared.'),
            submitButtonText: yext.msg('OK'),
            onSubmit: function() {
              this.postContentController.clearPhotoContent();
              this.postDestinationController.applyLocationChanges();
            }.bind(this),
            onCancel: function() {
              this.postDestinationController.resetLocationSelector();
            }.bind(this),
          });
        } else {
          this.postDestinationController.applyLocationChanges();
        }
      }.bind(this))
      .fail(function(data) {
        yext.notify.showError(yext.msg(
          'There was an error while updating your post\'s locations. Please try again.'));
        this.postDestinationController.resetLocationSelector();
      });
  } else {
    this.postDestinationController.applyLocationChanges();
  }
};

/**
 * @private
 * @return {string} locationSearchParam
 */
yext.social.post.PostBoxController.prototype.encodeLocationSearchParam_ = function() {
  var destinationData = this.postDestinationController.getData();
  if (destinationData['locationIds'] && destinationData['locationIds'].length > 0) {
    return encodeURIComponent('entityIds=' + destinationData['locationIds'].join(','));
  } else if (destinationData['folderIds'] && destinationData['folderIds'].length > 0) {
    return encodeURIComponent('folderIds=' + destinationData['folderIds'].join(','));
  } else if (destinationData['locationLabelIds'] && destinationData['locationLabelIds'].length > 0) {
    return encodeURIComponent(['labelIds='] + destinationData['locationLabelIds'].join(','));
  } else {
    return encodeURIComponent('allLocationsPost=true');
  }
};

/** @private */
yext.social.post.PostBoxController.prototype.toggleSubmitButton_ = function() {
  var error = this.validator.validate(this.getData());
  var data = this.getData();
  var publisherSpecificError = this.validator.doPublisherSpecificValidation(data);
  this.toggleSubmit_(
    error == null
    && publisherSpecificError == null);

  if (publisherSpecificError) {
    this.$ctxt.find('.js-post-error')
      .text(publisherSpecificError)
      .show();
  } else {
    this.$ctxt.find('.js-post-error').hide();
  }
};

/**
 * @param {boolean} enabled
 * @private
 */
yext.social.post.PostBoxController.prototype.toggleSubmit_ = function(enabled) {
  this.$ctxt.find('.js-submit-action-menu').find('button').prop('disabled', !enabled);
};

/**
 * @private
 * @param {yext.social.post.Partner} partner
 * @param {function()} onApprove
 */
yext.social.post.PostBoxController.prototype.onSelectPartner_ =
  function(partner, onApprove) {
    this.fieldConfiguration.updatePartner(partner);
    onApprove();
  };
